import { render, staticRenderFns } from "./ReferralPurchaseEdit.vue?vue&type=template&id=6c120b21&scoped=true"
import script from "./ReferralPurchaseEdit.vue?vue&type=script&lang=js"
export * from "./ReferralPurchaseEdit.vue?vue&type=script&lang=js"
import style0 from "./ReferralPurchaseEdit.vue?vue&type=style&index=0&id=6c120b21&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c120b21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c120b21')) {
      api.createRecord('6c120b21', component.options)
    } else {
      api.reload('6c120b21', component.options)
    }
    module.hot.accept("./ReferralPurchaseEdit.vue?vue&type=template&id=6c120b21&scoped=true", function () {
      api.rerender('6c120b21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/referral_purchase/ReferralPurchaseEdit.vue"
export default component.exports